export const HEADERS = {
    'socios': ['Nombre', 'Apellido(s)', 'Email', 'Tlf', 'DNI', 'Status', 'Tipo de socio'],
    'solicitudes': ['Nombre', 'Apellido(s)', 'Email', 'Conocido', 'Tipo de socio'],
    'invitaciones': ['Nombre', 'Email', 'Tipo de socio'],
    'eventos': ['', 'Nombre del evento', 'Fecha', 'Status'],
    'promos': ['', 'Nombre de la promoción', 'Código', 'Usuarios']
}